import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import almond from '../img/projectsImage/almond.jpg';
import chai from '../img/projectsImage/chai.jpg';
import basantidhaba from '../img/projectsImage/basantidhaba.jpg';

const Services = () => {
  const services = [
    "GLOW SIGN BOARD",
    "ACRYLIC LETTERS SIGNS",
    "METAL LETTERS WITH BACKGLOW",
    "3D & 2D LED BOARDS",
    "NEON SIGN BOARD",
    "DIGITAL SIGNS",
    "ACP BOARDS",
    "WPC BOARDS",
    "SAFETY SIGNS",
    "INNER CUT SIGNS",
    "VINYL WITH LAMINATION",
    "FLEX BOARD FRONTLIT & BACKLIT",
    "BANNER",
    "SUN CONTROL FILM",
    "FROSTED VIYNLS",
    "COMMERCIAL & RESIDENTIAL SIGNS",
    "WOODEN SIGNS",
  ];

  const serviceImages = {
    "GLOW SIGN BOARD": [almond, chai, basantidhaba],
    "ACRYLIC LETTERS SIGNS": [almond, chai, basantidhaba],
    "METAL LETTERS WITH BACKGLOW": [almond, chai, basantidhaba],
    "3D & 2D LED BOARDS": [almond, chai, basantidhaba],
    // more add here
  };

  const [selectedService, setSelectedService] = useState(null);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  return (
    <section className="bg-[#f9f9f9] section relative mt-[10px] lg:mt-0 lg:py-10 xl:pb-20">
      <div className="container mx-auto">
        <motion.h2
          variants={fadeIn('up')}
          initial="hidden"
          whileInView={'show'}
          viewport={{ once: false, amount: 0.6 }}
          className="h2 max-w-[370px] lg:mb-15"
        >
          Our Services
        </motion.h2>
      </div>
      <motion.div
        variants={fadeIn('up')}
        initial="hidden"
        whileInView={'show'}
        viewport={{ once: false, amount: 0.2 }}
        className="flex flex-wrap justify-center p-4 gap-3"
      >
        {services.map((service, index) => (
          <div
            key={index}
            onClick={() => setSelectedService(service)}
            className="cursor-pointer px-6 py-2 text-sm font-medium border rounded-full text-gray-700 border-gray-300 hover:bg-dark hover:text-white transition-colors duration-300 shadow-md"
          >
            {service}
          </div>
        ))}
      </motion.div>

      {/* Modal for Selected Service */}
      {selectedService && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white w-[90%] max-w-2xl rounded-lg shadow-lg p-6 relative">
            <h3 className="text-xl font-semibold text-center mb-5">
              {selectedService}
            </h3>
            <Slider {...sliderSettings}>
              {serviceImages[selectedService].map((image, idx) => (
                <div key={idx} className="px-2">
                  <img
                    src={image}
                    alt={`${selectedService} ${idx + 1}`}
                    className="w-full h-auto rounded-lg"
                  />
                </div>
              ))}
            </Slider>
            <button
              onClick={() => setSelectedService(null)}
              className="absolute top-3 right-3 text-gray-600 hover:text-gray-900"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Services;